import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Constat } from "@/components/landing/Constat";
import { Concept } from "@/components/landing/Concept";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Product } from "@/components/landing/Product";
import { Timeline } from "@/components/landing/Timeline";
import { Why } from "@/components/landing/Why";
import { Development } from "@/components/landing/Development";
import { Reserve } from "@/components/landing/Reserve";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";
import { StickyCta } from "@/components/landing/StickyCta";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Constat />
      <Concept />
      <HowItWorks />
      <Product />
      <Timeline />
      <Why />
      <Development />
      <Reserve />
      <Faq />
      <Footer />
      <StickyCta />
    </main>
  );
}
